const menuFooterSections = {
    top: ['sklepy', 'jak_kupowac', 'obsluga_klienta', 'uslugi'],
    bottom: {
        first: ['zobacz_rowniez', 'poznaj_nas'],
        second: ['kwestie_prawne', 'dane_osobowe'],
    },
};

export default menuFooterSections;
